import { iconA11y, type IconProps } from './iconProps';

/**
 * Lowercase “i” mark for the compact flyways info control.
 * Square stem + square tittle — matches Figma Frame 21384554 (straight edges).
 */
export function InfoIcon({ size = 24, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <rect x="10.875" y="5.5" width="2.25" height="2.25" fill="currentColor" />
      <rect x="10.875" y="10.5" width="2.25" height="8.5" fill="currentColor" />
    </svg>
  );
}
